var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsterik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7273 4.72727C12.7273 4.32561 12.4017 4 12 4C11.5983 4 11.2727 4.32561 11.2727 4.72727V11.2727H4.72727C4.32561 11.2727 4 11.5983 4 12C4 12.4017 4.32561 12.7273 4.72727 12.7273H11.2727V19.2727C11.2727 19.6744 11.5983 20 12 20C12.4017 20 12.7273 19.6744 12.7273 19.2727V12.7273H19.2727C19.6744 12.7273 20 12.4017 20 12C20 11.5983 19.6744 11.2727 19.2727 11.2727H12.7273V4.72727Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60517 9.60517C9.32115 9.88919 8.86067 9.88919 8.57665 9.60517L6.39483 7.42335C6.11082 7.13933 6.11082 6.67885 6.39483 6.39483C6.67885 6.11081 7.13933 6.11081 7.42335 6.39483L9.60517 8.57665C9.88919 8.86067 9.88919 9.32115 9.60517 9.60517Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6052 7.42335C17.8892 7.13933 17.8892 6.67885 17.6052 6.39483C17.3212 6.11081 16.8607 6.11081 16.5767 6.39483L14.3948 8.57664C14.1108 8.86066 14.1108 9.32115 14.3948 9.60516C14.6789 9.88918 15.1393 9.88918 15.4234 9.60516L17.6052 7.42335Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60517 14.3948C9.88919 14.6788 9.88919 15.1393 9.60517 15.4234L7.42335 17.6052C7.13934 17.8892 6.67885 17.8892 6.39484 17.6052C6.11082 17.3211 6.11082 16.8607 6.39484 16.5766L8.57665 14.3948C8.86067 14.1108 9.32115 14.1108 9.60517 14.3948Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5767 17.6052C16.8607 17.8892 17.3212 17.8892 17.6052 17.6052C17.8892 17.3212 17.8892 16.8607 17.6052 16.5766L15.4234 14.3948C15.1393 14.1108 14.6789 14.1108 14.3948 14.3948C14.1108 14.6788 14.1108 15.1393 14.3948 15.4233L16.5767 17.6052Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterik);
export default __webpack_public_path__ + "static/media/asterik.7caebd09ba0271e469718848793257d0.svg";
export { ForwardRef as ReactComponent };